<template>
    <div>
        <az-call-to-action :active=false dark hide-border @click="mostrarDialog = true"
                           css-class="no-mobile
                           botao-cancelar-envio-proposta">
            Cancelar Envio
        </az-call-to-action>
        <!--confirmacao envio da proposta -->
        <az-confirm @onConfirm="cancelarEnvio(); mostrarDialog = false;" @onDecline="mostrarDialog = false"
                    v-if="mostrarDialog" :maxWidth=350>
            Deseja realmente cancelar o envio da proposta?
        </az-confirm>
    </div>
</template>

<script>
    import {mapActions, mapState} from 'vuex'
    import {actionTypes} from '@/commons/constants'

    export default {
        name: 'CredenciamentoFornecedorAcoesCancelarEnvio',
        data() {
            return {
                globalLoadingAtivado: false,
                mostrarDialog: false
            }
        },
        computed: {
            ...mapState(['propostaResumo', 'licitacao'])
        },
        methods: {
            async cancelarEnvio() {
                this.habilitarLoading()
                try {
                    if(this.licitacao.status !== 'AGUARDANDO_ABERTURA'){
                      this.mostrarNotificacaoErro('Só é possível cancelar propostas em licitações com o status "Aguardando Abertura".')
                      return
                    }
                    await this.efetuarCancelamento()
                    await this.sincronizarProposta()
                    this.mostrarNotificacaoSucessoDefault()
                    this.desabilitarLoading()
                } catch (e) {
                    this.desabilitarLoading()
                }
            },
            desabilitarLoading() {
                if (!this.globalLoadingAtivado) {
                    this.desabilitarLoadingGlobal()
                }
            },
            async efetuarCancelamento() {
                this.setMensagemLoading('Cancelando envio da proposta...')
                const params = {
                    licitacaoId: this.propostaResumo.licitacao.id
                }
                await this.cancelarEnvioProposta(params)
            },
            habilitarLoading() {
                this.globalLoadingAtivado = this.loki.isGlobalLoadingEnabled
                this.habilitarLoadingGlobal()
            },
            async sincronizarProposta() {
                this.setMensagemLoading('Carregando dados da Proposta...')
                await this.buscarPropostaResumo(this.propostaResumo.licitacao.id)
            },
            ...mapActions([actionTypes.BUSCAR_PROPOSTA_RESUMO, actionTypes.CANCELAR_ENVIO_PROPOSTA])
        }
    }
</script>
<style lang="stylus">
.botao-cancelar-envio-proposta
  padding-left 8px !important
  padding-right 8px !important
</style>
